import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import VideoSourceDropdownComp from 'components/SourceDisplay/VideoSourceDropdown';
import MicrophoneDropdown from 'containers/MicrophoneDropdown/MicrophoneDropdown';
import SpeakerDropdown from 'containers/SpeakerDropdown/SpeakerDropdown';
import PreviewVideo from 'components/PreviewVideo/PreviewVideo';
import classes from './SourceDisplay.module.scss';

// TODO something about the router causes componentDidMount to fire twice, temp fix here
let acquireLocalStreamStarted = false;

export class SettingsSourceDisplay extends React.Component {
  UNSAFE_componentWillMount() {
    acquireLocalStreamStarted = !this.props.isAcquiringPrimaryStream;
  }

  componentDidMount() {
    if (acquireLocalStreamStarted &&
      !this.props.isAcquiringPrimaryStream) {
      acquireLocalStreamStarted = false;
      this.props.acquireLocalPrimaryStream();
    }
  }

  componentWillUnmount() {
    this.props.endLocalStream();
  }

  render() {
    const {
      defaultVideoSetting,
      videoDevices,
      permissionOnly
    } = this.props;

    if (permissionOnly) {
      return <div />;
    }

    return (
      <div className={classes.container}>
        <div className={classes.avPanels}>
          <section>
            <div className={`${classes.subHeading} ${classes.smallSubHeading}`}>
              <FormattedMessage
                id="components.avSettingsModal.camera"
                defaultMessage="Camera"
              />
            </div>
            <div className={classes.dropdownContainer} >
              {videoDevices.length ?
                <VideoSourceDropdownComp
                  videoDevices={this.props.videoDevices}
                  selectVideoSource={this.props.selectVideoSource}
                  defaultAudioSetting={this.props.defaultAudioSetting}
                  defaultVideoSetting={this.props.defaultVideoSetting}
                  selectedVideoLabel={this.props.selectedVideoLabel}
                  titleClass={classes.settingsTitle}
                />
                :
                <div className={classes.emptyDropdown}>
                  <FormattedMessage
                    id="components.avSettingsModal.noCamera"
                    defaultMessage="No camera detected"
                  />
                </div>
              }
            </div>
            <PreviewVideo defaultVideoSetting={defaultVideoSetting} />
          </section>
          <section>
            <div className={classes.audioSelection}>
              <MicrophoneDropdown
                defaultAudioSetting={this.props.defaultAudioSetting}
                defaultVideoSetting={this.props.defaultVideoSetting}
                selectedAudioLabel={this.props.selectedAudioLabel}
                selectAudioSource={this.props.selectAudioSource}
                acquireLocalPrimaryStream={this.props.acquireLocalPrimaryStream}
                setVideoEnabledDefault={this.props.setVideoEnabledDefault}
                setAudioEnabledDefault={this.props.setAudioEnabledDefault}
                selectedSources={this.props.selectedSources}
                toggleAudioMuteSetting={this.props.toggleAudioMuteSetting}
                titleClass={classes.settingsTitle}
              />
              <div>
                <SpeakerDropdown
                  selectAudioOutput={this.props.selectAudioOutput}
                  defaultVideoSetting={this.props.defaultVideoSetting}
                  defaultAudioSetting={this.props.defaultAudioSetting}
                  selectedAudioOutputId={this.props.selectedAudioOutputId}
                  selectedAudioOutputLabel={this.props.selectedAudioOutputLabel}
                  titleClass={classes.settingsTitle}
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

SettingsSourceDisplay.propTypes = {
  acquireLocalPrimaryStream: PT.func.isRequired,
  endLocalStream: PT.func.isRequired,
  audioDevices: PT.array.isRequired,
  videoDevices: PT.array.isRequired,
  selectedSources: PT.object,
  selectVideoSource: PT.func,
  selectAudioSource: PT.func,
  setVideoEnabledDefault: PT.func,
  setAudioEnabledDefault: PT.func,
  selectAudioOutput: PT.func,
  defaultVideoSetting: PT.bool,
  defaultAudioSetting: PT.bool,
  selectedVideoLabel: PT.string,
  selectedAudioLabel: PT.string,
  selectedAudioOutputLabel: PT.string,
  selectedAudioOutputId: PT.string,
  isAcquiringPrimaryStream: PT.bool,
  toggleAudioMuteSetting: PT.func,
  permissionOnly: PT.bool
};

export default SettingsSourceDisplay;
